<template>
  <div class="shopMember">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/order/orderAll' }">订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>已完成</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="shop-screen">
      <el-button
        type="primary"
        size="small"
        style="background: #4781d9; border: 0"
        class="btn-item"
        @click="chainGoodExport"
      >
        <span>导出</span>
        <i class="iconfont icon-daochu" style="font-size:12px"></i>
      </el-button>
      <el-form
        ref="form"
        :model="searchForm"
        label-width="100px"
        size="mini"
        class="shopScreenForm"
      >
        <el-form-item label="门店名称">
          <el-input v-model="searchForm.shop_name" style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model="searchForm.order_no" style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户电话">
          <el-input v-model="searchForm.phone" style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动类型">
          <el-select v-model="searchForm.activity_type" placeholder="请选择"  style="width: 200px">
            <el-option label="小红书" :value="1" />
            <el-option label="大众点评" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="searchForm.created_at"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="活动完成时间">
          <el-date-picker
            v-model="searchForm.activity_back_time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            style="background: #cd0550; border: none"
            @click="search"
            >搜索</el-button
          >
          <el-button @click="emptySearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 查看活动要求 -->
    <el-dialog
      :visible.sync="visibleRequirement"
      title="查看活动要求"
    >
      <div v-if="currentData">
        <div class="review-title">笔记要求</div>
        <div class="review-info">
          <div class="review-info-lf">笔记图片数量（最低多少张）：</div>
          <div class="review-info-rg">{{ currentData.picture_need }}</div>
        </div>
        <div class="review-info">
          <div class="review-info-lf">笔记字数数量（最低多少字）：</div>
          <div class="review-info-rg">{{ currentData.words_need }}</div>
        </div>
        <div class="review-info">
          <div class="review-info-lf">携带话题（多个用#隔开）：</div>
          <div class="review-info-rg">{{ currentData.topics }}</div>
        </div>
        <div class="review-info">
          <div class="review-info-lf">添加门店定位（定位文字，10个字以内）：</div>
          <div class="review-info-rg">{{ currentData.shop_location }}</div>
        </div>
        <div class="review-title" style="margin-top:30px;">客户上传笔记</div>
        <div class="review-info">
          <div class="review-info-lf">上传时间：</div>
          <div class="review-info-rg">{{ currentData.created_at }}</div>
        </div>
        <div class="review-info">
          <div class="review-info-lf">笔记地址：</div>
          <div class="review-info-rg">{{ currentData.note_url }}</div>
        </div>
        <div class="review-info">
          <div class="review-info-lf">笔记截图：</div>
          <div class="review-info-rg">
            <div v-if="currentData&&currentData.note_images" style="display: flex;flex-wrap: wrap;">
              <div v-for="(item,index) in JSON.parse(currentData.note_images)" :key="index">
                <img :src="imgUrl+item" style="width:100px;height:100px;margin-right:5px;" @click="dialogVisible=true">
              </div>
            </div>
          </div>
        </div>
        <div class="review-title" style="margin-top:30px;">笔记审核结果</div>
        <div class="review-info">
          <div class="review-info-lf">审核结果：</div>
          <div class="review-info-rg">{{ currentData.note_status==1?'平台审核中':currentData.note_status==2?'审核失败':'审核通过' }}</div>
        </div>
         <div class="review-info" v-if="currentData.note_status==3">
          <div class="review-info-lf">通过时间：</div>
          <div class="review-info-rg">{{ currentData.examine_time }}</div>
        </div>
        <div class="review-info" v-if="currentData.note_status==2">
          <div class="review-info-lf">不通过原因：</div>
          <div class="review-info-rg">{{ currentData.failure_reason }}</div>
        </div>
      </div>
      <div v-else style="text-align:center;">未上传</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleRequirement=false">关 闭</el-button>
      </span>
    </el-dialog>
     <!-- 预览图 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :modal="false"
    >
      <div v-if="currentData&&currentData.note_images">
        <div v-for="(item,index) in JSON.parse(currentData.note_images)" :key="index">
          <img :src="imgUrl+item" style="width:100%;">
        </div>
      </div>
    </el-dialog>
    <div class="data-table">
      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
        type="index"
        :header-cell-style="{ background: '#CD0550', color: '#fff' }"
      >
        <el-table-column prop="order_no" label="订单号"/>
        <el-table-column prop="shop_info.name" label="门店名称"/>
        <el-table-column prop="good_info.good_name" label="商品名称 "/>
        <el-table-column prop="price" label="团购价"/>
        <el-table-column prop="activity_price" label="活动价"/>
        <el-table-column prop="user_info.phone" label="用户手机号"/>
        <el-table-column prop="pickup_code" label="取盒码"/>
        <el-table-column prop="created_at" label="下单时间"/>
        <el-table-column label="取盒时间">
          <template slot-scope="scope">
            {{ scope.row.pickup_time_start+' - '+scope.row.pickup_time_end }}
          </template>
        </el-table-column>
        <el-table-column prop="activity_back_time" label="活动完成时间"/>
        <el-table-column label="活动类型">
          <template slot-scope="scope">
            {{ scope.row.activity_type==1?'小红书':'大众点评' }}
          </template>
        </el-table-column>
        <el-table-column label="订单状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status==0">待支付</span>
            <span v-if="scope.row.status==1">已支付</span>
            <span v-if="scope.row.status==2">已核销</span>
            <span v-if="scope.row.status==3">商户退款</span>
            <span v-if="scope.row.status==4">用户申请退款</span>
            <span v-if="scope.row.status==5">取消</span>
            <span v-if="scope.row.status==6">自动退款</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div style="position: relative; display: inline">
              <i
                style="color: #3ca6f0"
                @click.stop="operation(scope.row)"
                class="iconfont icon-bianji"
              >
              </i>
              <div v-if="scope.row.num == num" class="operation">
                <p @click.stop="seeGoods(scope.row)" :class="active == 1 ? 'active' : ''">
                  查看活动要求
                </p>
                
              </div>
            </div>
          </template>
      </el-table-column>
      </el-table>
      <div class="page-num">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageSizes"
          :page-size="pageSize"
          layout="prev,pager,next, total,sizes,jumper"
          :total="total"
          background
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrderList,getNoteDetail } from "@/api/shiChiGuanOrder.js"
import { imgUrl} from "@/utils/http.js"
import axios from "axios"
import { httpUrl } from "@/utils/http.js"

export default {
  data() {
    return {
      imgUrl:imgUrl,
      searchForm: {
        shop_name: "",
        order_no: "",
        phone:'',
        activity_type:'',
        is_complete:1,
        created_at:[],
        activity_back_time:[]
      },
      currentPage: 1,
      pageSizes: [10, 20, 50],
      pageSize: 10,
      total: 0,
      tableData: [],
      num: 0,
      active: 1,
      filename: "已完成订单",
      active: 1,
      num: 0,
      currentData:null,
      visibleRequirement:false,
      dialogVisible:false
    }
  },
  methods: {
    //重置
    emptySearch() {
      this.currentPage = 1
      this.pageSize = 10
      this.searchForm={
        shop_name: "",
        order_no: "",
        phone:'',
        activity_type:'',
        created_at:[],
        activity_back_time:[]
      }
      this.getOrderList()
    },
    //搜索
    search() {
      this.currentPage = 1
      this.getOrderList()
    },
    //改变条数
    handleSizeChange(e) {
      this.pageSize = e
      this.getOrderList()
    },
    //切换页
    handleCurrentChange(e) {
      this.currentPage = e
      this.getOrderList()
    },
    //获取订单列表
    async getOrderList() {
      let res = await getOrderList({
        ...this.searchForm,
        page: this.currentPage,
        limit: this.pageSize,
      })
      this.tableData = res.data.data.list;
      this.total = res.data.data.total_count;
       this.tableData.forEach((item, index) => {
        item.num = index + 1
      })
    },
    //获取笔记详情
    async getNoteDetail(row) {
      let res = await getNoteDetail({order_id:row.id})
      this.currentData=res.data.data
    },
     //查看
    seeGoods(row){
       this.currentData=null
     this.getNoteDetail(row)
     this.visibleRequirement=true
    },
    //显示操作页面
    operation(row) {
      if (this.num == row.num) {
        this.num = 0
      } else {
        this.num = row.num
      }
    },
     //导出
     chainGoodExport1() {
      const loading = this.$loading({
        lock: true,
        text: '导出中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      // 使用 URLSearchParams 构建查询字符串
      const params = new URLSearchParams();
      params.append('shop_name', this.searchForm.shop_name);
      params.append('order_no', this.searchForm.order_no);
      params.append('phone', this.searchForm.phone);
      params.append('activity_type', this.searchForm.activity_type);
      params.append('is_complete', 1);

      // 处理 created_at 数组
      if (this.searchForm.created_at && this.searchForm.created_at.length === 2) {
        params.append('created_at_start', this.searchForm.created_at[0]);
        params.append('created_at_end', this.searchForm.created_at[1]);
      }

      // 处理 activity_back_time 数组
      if (this.searchForm.activity_back_time && this.searchForm.activity_back_time.length === 2) {
        params.append('activity_back_time_start', this.searchForm.activity_back_time[0]);
        params.append('activity_back_time_end', this.searchForm.activity_back_time[1]);
      }

      const url = `${httpUrl}api/v2/chain/try/chainOrderExport?${params.toString()}`;

      axios.get(url, { responseType: 'blob' })
        .then((res) => {
          // 处理导出逻辑...
        })
        .catch((err) => {
          this.$message.error('导出失败,请重试!');
          loading.close();
        });
    },
    // 导出
    chainGoodExport() {
      const loading = this.$loading({
        lock: true,
        text: '导出中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      // 使用 URLSearchParams 构建查询字符串
      const params = new URLSearchParams();
      params.append('shop_name', this.searchForm.shop_name);
      params.append('order_no', this.searchForm.order_no);
      params.append('phone', this.searchForm.phone);
      params.append('activity_type', this.searchForm.activity_type);
      params.append('is_complete', 1);

      // 处理 created_at 数组 - 保持数组格式
      if (this.searchForm.created_at && this.searchForm.created_at.length > 0) {
        this.searchForm.created_at.forEach(date => {
          params.append('created_at[]', date); // 使用 created_at[] 格式
        });
      }

      // 处理 activity_back_time 数组 - 保持数组格式
      if (this.searchForm.activity_back_time && this.searchForm.activity_back_time.length > 0) {
        this.searchForm.activity_back_time.forEach(date => {
          params.append('activity_back_time[]', date); // 使用 activity_back_time[] 格式
        });
      }

      const url = `${httpUrl}api/v2/chain/try/chainOrderExport?${params.toString()}`;

      axios.get(url, { responseType: 'blob' })
        .then((res) => {
          if (!res) return;
          const blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });

          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, this.filename);
          } else {
            const href = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.style.display = "none";
            a.href = href;
            a.download = this.filename;
            a.click();
            URL.revokeObjectURL(a.href);
            loading.close()
          }
        })
        .catch((err) => {
          this.$message.error('导出失败,请重试!');
          loading.close()
        });
    }
  },
  created() {
    this.getOrderList()
  }
}
</script>

<style lang="less" scoped>
.shopMember {
  width: 100%;
  height: 100%;
  background: #eee;
  box-sizing: border-box;
  padding: 30px;
}
.shop-screen {
  background: #ffffff;
  border-radius: 5px;
  padding: 20px;
  box-sizing: border-box;
  margin-top: 20px;
}
.shopScreenForm {
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  font-weight: bold;
  color: #666666;
  margin-top: 20px;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #cd0550 !important;
}
/deep/.el-pager li {
  border: 1px solid #bfbfbf;
  background: #fff !important;
  box-sizing: border-box !important;
}
/deep/.el-pagination.is-background .btn-next {
  border: 1px solid #bfbfbf;
  background: #fff !important;
}
/deep/.el-pagination.is-background .btn-prev {
  border: 1px solid #bfbfbf;
  background: #fff !important;
}
/deep/.el-table {
  overflow: visible;
}
/deep/td {
  text-align: center !important;
}
/deep/.cell {
  text-align: center !important;
  overflow: visible;
}
/deep/.el-table__body-wrapper {
  overflow: visible;
}
/deep/.is-active {
  color: #cd0550;
}
/deep/.el-tabs__active-bar {
  background: #cd0550;
}
.data-table {
  margin-top: 20px;
  background: #fff;
  border-radius: 5px;
  overflow: hidden;
}
.page-num {
  display: flex;
  justify-content: flex-end;
  padding: 30px;
}
.operation {
  cursor: pointer;
  position: absolute;
  top: 0px;
  left: -105px;
  z-index: 99;
  background: #fff;
  p {
    width: 100px;
    height: 40px;
    // background: rgba(246, 219, 229, 0.2);
    border-radius: 0px;
    text-align: center;
    line-height: 40px;
    border: 1px #eee solid;
    font-size: 14px;
    font-weight: bold;
    color: #999999;
  }
}
.active {
  background: #cd0550 !important;
  color: #fff !important;
}
.btn-list {
  display: flex;
  align-items: center;
}
 .review-title{
  font-size: 16px;
  color:#333;
  font-weight: 600;
}
.review-info{
  display: flex;
  align-items: center;
  margin: 15px 0;
}
.review-info-lf{
  font-size: 13px;
  color:#333;
  margin-right: 5px;
}
.review-info-rg{
  font-size: 13px;
  color:#999;
}
</style>